function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.98024 12H12.0202C13.0469 12 13.6869 10.8866 13.1736 9.99996L8.15358 1.32662C7.64024 0.439954 6.36024 0.439954 5.84691 1.32662L0.82691 9.99996C0.313577 10.8866 0.953577 12 1.98024 12ZM7.00024 7.33329C6.63358 7.33329 6.33358 7.03329 6.33358 6.66662V5.33329C6.33358 4.96662 6.63358 4.66662 7.00024 4.66662C7.36691 4.66662 7.66691 4.96662 7.66691 5.33329V6.66662C7.66691 7.03329 7.36691 7.33329 7.00024 7.33329ZM7.66691 9.99996H6.33358V8.66662H7.66691V9.99996Z",
  fill: "#F57762CC"
});

var SvgCriticalAlertsIcon = function SvgCriticalAlertsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCriticalAlertsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/critical_alerts_icon.77077508.svg";
export { ForwardRef as ReactComponent };